import { useEffect } from "react";

const CSS_VAR_APP_HEIGHT = "--app__height";
const CSS_VAR_APP_HEIGHT_START = "--app__height-start";

const setAppProperty = (property) => {
  document.documentElement.style.setProperty(property, `${window.innerHeight}px`);
};

const setAppHeight = () => setAppProperty(CSS_VAR_APP_HEIGHT);
const setAppHeightStart = () => setAppProperty(CSS_VAR_APP_HEIGHT_START);

const useAppHeight = () => {
  useEffect(() => {
    setAppHeight();
    setAppHeightStart();
    window.addEventListener("resize", setAppHeight);

    return () => {
      window.removeEventListener("resize", setAppHeight);
    };
  }, []);
};

export default useAppHeight;
